import React, { useState } from "react";

import "../HeaderComponent/Header.css";
import { MdOutlineSyncProblem } from "react-icons/md";
import { TbArrowsTransferUp } from "react-icons/tb";
import { FaUsersLine } from "react-icons/fa6";
import { TbCornerUpRightDouble } from "react-icons/tb";
import { RiCornerUpRightDoubleFill } from "react-icons/ri";
import { BsWallet2 } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { FaSquarePollVertical } from "react-icons/fa6";
import { navbarColor, primaryColor } from "../../utils/comman/Common";

const Menu = () => {
  const headerIconColor = process.env.REACT_APP_NAV_MENU_ICON_COLOR_DEFAULT;
  const params = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleCollapse = () => {
    setIsCollapsed(true);
  };
  return (
    <div class="menu">
      <nav
        style={{ padding: 0, margin: 0, backgroundColor: navbarColor }}
        className="navbar navbar-expand-lg navbar-dark "
      >
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        {/* <div class="collapse navbar-collapse" id="navbarSupportedContent"> */}
        <div
          id="navbarSupportedContent"
          className={`collapse navbar-collapse ${isCollapsed ? "" : "show"}`}
        >
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <NavLink
                to="/dashboard"
                class={params.pathname === "/dashboard" && "active"}
                onClick={handleCollapse}
              >
                <TbArrowsTransferUp
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>Home</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/pay-in"
                class={params.pathname === "/pay-in" && "active"}
                onClick={handleCollapse}
              >
                <TbArrowsTransferUp
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>PayIn</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/pay-out"
                class={params.pathname === "/pay-out" && "active"}
                onClick={handleCollapse}
              >
                <TbCornerUpRightDouble
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>Payout</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/user-list"
                class={params.pathname === "/user-list" && "active"}
                onClick={handleCollapse}
              >
                <FaUsersLine
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>User List</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/ticket"
                class={params.pathname === "/ticket" && "active"}
                onClick={handleCollapse}
              >
                <MdOutlineSyncProblem
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>Ticket</span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/merchant-wallet-ledger"
                class={
                  params.pathname === "/merchant-wallet-ledger" && "active"
                }
                onClick={handleCollapse}
              >
                <BsWallet2
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>Wallet Ledger </span>
              </NavLink>
            </li>
            <li class="nav-item active">
              <NavLink
                to="/report"
                class={params.pathname === "/report" && "active"}
                onClick={handleCollapse}
              >
                <FaSquarePollVertical
                  size={20}
                  style={{ marginBottom: "5px", color: headerIconColor }}
                />{" "}
                <span>Report</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Menu;
